"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = exports.initializeClientSideInlineLogger = exports.inlineLoggerReady = void 0;
exports.getMeterAsync = getMeterAsync;
const internal_1 = require("./internal");
const common_1 = require("./common");
const inlineLoggerReady = () => 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, internal_1.onInlinerEventStatus)().then(({ status, ...result }) => result);
exports.inlineLoggerReady = inlineLoggerReady;
//
const initializeClientSideInlineLogger = async (args = {}) => {
    let errorState = null;
    const loggerInvariantState = (0, common_1.withInvariantState)();
    window.addEventListener(common_1.EventTypeInlinerAck, (e) => {
        if (e.detail.status === "Failure") {
            errorState = e.detail.error;
            args.onError?.(e.detail.error);
        }
        else if (e.detail.status !== "Initialize") {
            loggerInvariantState.update(e.detail.logger);
        }
    });
    // We want to ensure that the inliner is preloaded before continuing.
    // It's fine to ignore the return value here. Treat the above event listener
    // as the source of truth for updating the invariant state.
    await (0, exports.inlineLoggerReady)();
    return new Proxy(loggerInvariantState.value, {
        get(target, property, receiver) {
            if (!(property in loggerInvariantState.value))
                return Reflect.get(target, property, receiver);
            if (errorState !== null) {
                throw errorState;
            }
            return loggerInvariantState.value[property];
        },
    });
};
exports.initializeClientSideInlineLogger = initializeClientSideInlineLogger;
const consoleFallbackLogger = {
    log: (...x) => console.log(...x),
    error: (...x) => console.error(...x),
    event: (...x) => console.log(`[event]`, ...x),
};
/**
 * @info @warn by default, this logger will return something that logs to console if the
 * underlying implementation fails to instantiate.
 * If logging is so critical to your applications functionality that you would rather fail than not log,
 * you can opt-out of this implementation by passing `false` to `fallbackToConsoleLogger`
 * @param getLoggerArgs
 */
const getLogger = (getLoggerArgs) => {
    const fallbackToConsoleLogger = getLoggerArgs?.fallbackToConsoleLogger ?? true;
    const logger = typeof window !== "undefined" ? window[common_1.EBAY_RUM_LOGGER_SYMBOL] : undefined;
    if (!logger && fallbackToConsoleLogger) {
        console.warn(`Warning: ${String(common_1.EBAY_RUM_LOGGER_SYMBOL)} not found, error in initialization or server execution; using console logger.`);
        return consoleFallbackLogger;
    }
    (0, common_1.assert)(logger, `Logger was not defined. This indicates that the logger was not initialized properly. Check logs for more details`);
    return logger;
};
exports.getLogger = getLogger;
// TODO: Implement an `inlinerMeterReady` function to await meter initialization.
// Now, we provide a simple utility to get the meter with retries.
const DEFAULT_RETRIES = 10;
const DEFAULT_DELAY_MS = 500;
async function getMeterAsync(retries = DEFAULT_RETRIES, delayMs = DEFAULT_DELAY_MS) {
    if (typeof window === "undefined") {
        throw new Error("Running in non-browser environment");
    }
    const tryGet = () => window[common_1.EBAY_RUM_METER_SYMBOL];
    for (let attempt = 0; attempt <= retries; attempt++) {
        const meter = tryGet();
        if (meter)
            return meter;
        if (attempt === retries)
            break;
        await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
    throw new Error("EbayRumMeter failed to initialize within expected time");
}
